import makeApiCall from "./master/axiosIndex";
export const pmsMasterApis = {
  dayMasterList: async (): Promise<any> => {
    return makeApiCall({
      url: "/masters/dayMasterList",
      method: "get",
    });
  },
  labourTypesList: async (): Promise<any> => {
    return makeApiCall({
      url: "/masters/laborTypesList",
      method: "get",
    });
  },
  labourCatgoriesList: async (): Promise<any> => {
    return makeApiCall({
      url: "/masters/laborCatgoriesList",
      method: "get",
    });
  },
  getCurrencyTypes: (): Promise<any> =>
    makeApiCall({
      method: "get",
      url: "/misc/currencyTypes",
    }),
};
